import { Paper, styled } from "@mui/material";

export const MainPaper = styled(Paper)(({ theme }) => ({
  maxWidth: "75vw",
  margin: `${theme.spacing(2)} auto`,
  padding: theme.spacing(2.5),
}));

export const SectionPaper = styled(Paper)(({ theme }) => ({
  maxWidth: "75vw",
  margin: `${theme.spacing(1)} auto`,
  padding: theme.spacing(2.5),
}));